export class Person {
    name: string;
    emailAddress: string;
    phoneNumber: string;
    contactMethodPhone: boolean = true;
    contactMethodEmail: boolean;
    prefferedPhoneTime: string;
    hasOwnCar: boolean;
    ownCarRegistrationNumber: string;
    ownCarMileage: number;
    ownCarAdditionalInformation: string;
}
